import { useState, useEffect, useRef } from 'react'
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'

import './Surprise.scss'
import { sleep } from '../../../utils'
import MediaService from '../../../services/MediaService'

/**
 * The surprise video is shown after the user completes all days of a module.
 * It combines the user&apos;s recorded singing with the user&apos;s photos and their
 * influencer&apos;s photos to create a new photo montage.
 * @param {*} props
 * @returns
 */
export default function Surprise({
	background,
	song,
	slides,
	video,
	onSurpriseEnded,
	setDisplaySurprise,
	step_completed,
}) {
	// Sets up the initial variables to be used later
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)
	const dispatch = useDispatch()
	const [displayIntroVideo, setDisplayIntroVideo] = useState(false)
	const [displaySlideShow, setDisplaySlideShow] = useState(false)
	const [currentSlide, setCurrentSlide] = useState(0)

	const songEl = useRef()

	const cameraAudioSound = MediaService.getVideo(
		'/Module1Videos/camera_shutter.m4a',
		login
	)

	const ExitImage = MediaService.getImage('/Images/close.png', login)

	const handleIntroClose = () => {
		setDisplayIntroVideo(false)
		setDisplaySlideShow(true)
	}

	const handleSlideVideoEnded = () => {
		setCurrentSlide(currentSlide + 1)
	}

	const handleImageLoaded = async () => {
		await sleep(3500)
		setCurrentSlide(currentSlide + 1)
	}

	useEffect(() => {
		setDisplayIntroVideo(video ? true : false)
		setDisplaySlideShow(video ? false : true)
		setCurrentSlide(0)
	}, [video])

	useEffect(() => {
		if (currentSlide === slides.length - 1) {
			const sound = songEl.current

			let volume = 0.4

			const fadeAudio = setInterval(() => {
				// Fade music if not zero already
				if (volume > 0.02) {
					sound.volume = volume.toFixed(1)
					volume = volume.toFixed(1) - 0.1
				}
				// When volume at zero stop all the intervalling
				if (volume <= 0.0) {
					clearInterval(fadeAudio)
					if (step_completed) {
						dispatch({ type: step_completed, payload: 'surprise' })
					}
					onSurpriseEnded()
				}
			}, 1000)
		}
	}, [currentSlide])

	const VideoSlide = ({ slide }) => (
		<CloudfrontVideoFormat
			className="surprise-slide"
			source={slide}
			controls={false}
			background={background}
			onError={handleSlideVideoEnded}
			ended={handleSlideVideoEnded}
		/>
	)

	const ImageSlide = ({ slide }) => (
		<>
			<audio autoPlay>
				<source src={cameraAudioSound}></source>;
			</audio>
			<img
				className="image-slide photo-effect"
				src={slide}
				alt="slides"
				onError={handleImageLoaded}
				onLoad={handleImageLoaded}
			/>
		</>
	)

	// The HTML code to display the video player and run the slides.
	return (
		<div
			className="surprise-wrapper"
			style={{ backgroundImage: `url(${background})` }}
		>
			<img className="back-btn-ftb" alt="back bottun" src={ExitImage} onClick={() => setDisplaySurprise(false)} />

			{displayIntroVideo && (
				<CloudfrontVideoFormat
					className="fade-in surprise-slide"
					source={video}
					background={background}
					close={(val) => setDisplaySurprise(false)}
					ended={handleIntroClose}
				/>
			)}

			{displaySlideShow && (
				<>
					<audio autoPlay loop ref={songEl} onPlaying={()=>{songEl.current.volume = 0.4}}>
						<source src={song}></source>
					</audio>
					{slides.map((slide, idx) => {
						if (idx === currentSlide) {
							if (slide.includes('.mp4')) {
								return <VideoSlide key={`${idx}_video`} slide={slide} />
							}

							if (slide.includes('.jpg')) {
								return <ImageSlide key={`${idx}_slide`} slide={slide} />
							}
						}
					})}
				</>
			)}
		</div>
	)
}
